<template>
  <div class="row ma-0 pa-0">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 text-left">
      <span class="form-title">Dados cadastrais</span>

      <div class="row">

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
          v-model="formData.strCodigo"
          name="strCodigo"
          label="Código"
          :disabled="!formData.boolAtivo || !formData.boolPermitirEdicao"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
          v-model="formData.strNome"
          name="strNome"
          label="Descrição do Produto ou Serviço"
          required
          rules="required"
          :disabled="!formData.boolAtivo || !formData.boolPermitirEdicao"
        />

        <ed-input-text-area
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          v-model="formData.strDescricao"
          name="strDescricao"
          label="Observações"
          :disabled="!formData.boolAtivo || !formData.boolPermitirEdicao"
        />

        <ed-input-switch
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          v-model="formData.boolAtivo"
          name="boolAtivo"
          label="Serviço ativo?"
          :disabled="!formData.boolPermitirEdicao"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  EdInputText,
  EdInputTextArea,
  EdInputSelect,
  EdInputSwitch,
} from "@/components/common/form";

import CamposPersonalizado from "@/components/cadastro/formularioPersonalizado/formatar";
export default {
  name: "pageCadastroFuncao",
  props: {
    intFuncaoId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    formData: {
      type: [Object],
      required: false,
      default: null,
    },
  },
  components: {
    EdInputText,
    EdInputSelect,
    EdInputTextArea,
    EdInputSwitch,
    CamposPersonalizado,
  },
  mounted() {},
  created() {},
  data() {
    return {};
  },
  watch: {},
  methods: {},
};
</script>
